// extracted by mini-css-extract-plugin
export var ssoAccountsControls = "sso-accounts__controls_w6mtqvXx5dvyAhcZxVNT";
export var ssoAccountsLoadingContainer = "sso-accounts__loading-container_rgGcQHHrLs4gftmgCtV8";
export var ssoAccountsTabs = "sso-accounts__tabs_ChGFjHI9Y6TBjaSvZO8r";